import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Modal} from 'react-bootstrap'
import {connectForm} from '../../core/redux/form'
import DayRangePicker from '../../core/components/DayRangePicker'
import {CONTACT_FILTER_UPDATED} from '../actions'
import {Filter} from '../models'
import i18n from '../i18n'

class ContactFilterModal extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    render() {
        const {dispatch, contactFilter, form, onHide, ...others} = this.props

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.filterStats}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DayRangePicker
                        {...form(['from', 'to'])} />
                </Modal.Body>
            </Modal>
        )
    }
}

ContactFilterModal = connectForm({
    target: 'contactFilter',
    schema: Filter.schema,
    action: CONTACT_FILTER_UPDATED
})(ContactFilterModal)

ContactFilterModal = connect((state) => ({
    contactFilter: state.provider.contact.contactFilter
}))(ContactFilterModal)

export default ContactFilterModal


// WEBPACK FOOTER //
// ./lib/provider/components/ContactFilterModal.js